import { Container } from "unstated";

export class MiniNavigationContainer extends Container {
  state = {
    color: null,
    isExpanded: false,
    activeIndex: null,
    isHiding: false,
  };

  sectionTitles = ["performance", "design", "contact"];

  timeout = null;

  expand = (index) => {
    this.setState({ isExpanded: true, activeIndex: index });
  };

  collapse = () => {
    this.setState({ isExpanded: false });
  };

  show = () => {
    this.setState({ isHiding: false });
  };

  hide = () => {
    this.setState({ isHiding: true });
  };

  setActiveIndex = (index) => {
    this.setState({ activeIndex: index });
  };
}
